.a6{flex-direction:row;}